export default __webpack_public_path__ + "static/media/information--gas-station--g1.835ad032.png";